// extracted by mini-css-extract-plugin
export default {"root":"EmojiIconBackground-module__root"};